module.exports = __webpack_public_path__ + "static/img/img6x.d637b9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/family/img6x.png
// module id = 2Jyv
// module chunks = 1